const types = {
  CLEAN_UP: 'app/email/CLEAN_UP',
  CHECK_EMAIL: 'app/email/CHECK_EMAIL',
  CHECK_EMAIL_SUCCESS: 'app/email/CHECK_EMAIL_SUCCESS',
  CHECK_EMAIL_FAIL: 'app/email/CHECK_EMAIL_FAIL',
};

export default types;
